<template>
  <el-dialog title="添加题目" top="30vh" custom-class="ui-box-dialog" :visible.sync="dialogVisible" width="700px" :before-close="dialogBeforeClose">
    <el-form ref="form" class="ui-box-from-questionnaireDetail" label-position="right" :rules="rules" :model="questionnaire" label-width="85px">
      <el-form-item label="题目类型">
        <el-select class="ui-box-from-questionnaireDetail-input " v-model="questionnaire.tbType" placeholder="请选择" @change="tbTypeChange">
          <el-option label="单选题" :value="1"></el-option>
          <el-option label="多选题" :value="2"></el-option>
          <el-option label="判断题" :value="3"></el-option>
          <el-option label="简答题" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目名称">
        <el-input class="ui-box-from-questionnaireDetail-input" maxlength="255" v-model="questionnaire.tbQuestionnaireName"></el-input>
      </el-form-item>
      <template v-if="[1,2,3].includes(questionnaire.tbType)">
        <el-form-item :label="'选项'+(1+index)" v-for="(item,index) in questionnaire.questionnaireOptions" :key="index">
          <el-input maxlength="255" class="ui-box-from-questionnaireDetail-input " v-model="item.tbOptionsContent">
            <el-select style="select" v-model="item.tbIsInput" slot="prepend" placeholder="请选择">
              <el-option label="正常选项" :value="0"></el-option>
              <el-option label="可输入选项" :value="1"></el-option>
            </el-select>
          </el-input>
          <i class="el-icon-remove remove" @click="removeOption(index)"></i>
        </el-form-item>
      </template>
      <el-form-item label="" v-if="[1,2,3].includes(questionnaire.tbType)" style="margin-top:12px;">
        <div class="addOption" @click="addOption">+添加选项</div>
      </el-form-item>
      <el-form-item label="是否必答">
        <el-switch v-model="questionnaire.tbIsMustAnswer" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="ui-box-cancel" @click="dialogBeforeClose">取 消</el-button>
      <el-button class="ui-box-submit" type="primary" @click="save">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'addQuestionnairesDialog',
  props: {
    form: {
      type: Object
    },
    questionnaire: {
      type: Object
    },
    rules: {
    },
    dialogVisible: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {
    removeOption (index) {
      if (this.questionnaire.questionnaireOptions.length > 2) {
        this.questionnaire.questionnaireOptions = this.questionnaire.questionnaireOptions.filter((i, index1) => index1 !== index)
      } else {
        this.$message.error('选项不能少于俩个')
      }
    },
    addOption () {
      this.questionnaire.questionnaireOptions.push({
        tbOptionsContent: '',
        tbIsInput: 0
      })
    },
    tbTypeChange (val) {
      if ([1, 2].includes(this.questionnaire.tbType)) {
        this.questionnaire.questionnaireOptions = [{
          tbOptionsContent: '',
          tbIsInput: 0
        },
        {
          tbOptionsContent: '',
          tbIsInput: 0
        }]
      } else if ([3].includes(this.questionnaire.tbType)) {
        this.questionnaire.questionnaireOptions = [{
          tbOptionsContent: '是',
          tbIsInput: 0
        },
        {
          tbOptionsContent: '否',
          tbIsInput: 0
        }]
      } else if ([5].includes(this.questionnaire.tbType)) {
        this.questionnaire.questionnaireOptions = [{
          tbOptionsContent: '',
          tbIsInput: 0
        }]
      }
      this.$emit('update:questionnaire', this.questionnaire)
    },
    save () {
      const currentQuestionIndex = this.form.questionnaires.findIndex(i => i.tbSort === this.questionnaire.tbSort)
      if (currentQuestionIndex >= 0) {
        this.form.questionnaires[currentQuestionIndex] = this.questionnaire
      } else {
        this.form.questionnaires.push(this.questionnaire)
      }
      this.$emit('update:form', this.form)
      this.$emit('update:dialogVisible', false)
    },
    dialogBeforeClose () {
      this.$emit('update:dialogVisible', false)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ui-box-dialog {
  border-radius: 12px;
  ::v-deep .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  ::v-deep .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  .ui-box-from-questionnaireDetail {
    padding-top: 29px;
    ::v-deep .el-form-item {
      margin-top: 24px;
      margin-bottom: 0;
      ::v-deep .el-form-item__label {
        height: 32px;
        line-height: 32px;
        padding: 0;
        margin: 0;
      }
      ::v-deep .el-form-item__error {
        padding-left: 20px;
      }
      ::v-deep .el-form-item__content {
        height: 100%;
        padding-left: 20px;
        line-height: 32px;
      }
      .remove {
        color: #f56c6c;
        margin-left: 10px;
      }
      .width645 {
        width: 645px;
      }
      .ui-box-from-questionnaireDetail-input {
        width: 500px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.width645 {
          width: 645px;
        }
        ::v-deep .el-icon-time,
        ::v-deep .el-icon-arrow-down,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-icon-date,
        ::v-deep .el-range__icon,
        ::v-deep .el-range-separator,
        ::v-deep .el-range-input,
        ::v-deep .el-range__close-icon,
        ::v-deep .el-icon-circle-close,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
        ::v-deep .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          ::v-deep .el-input__inner::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        ::v-deep .el-input__inner[type="number"] {
          -moz-appearance: textfield;
        }
        ::v-deep .el-input-group__prepend {
          background-color: #fff;
          height: 30px;
          border: none;
          &::-moz-placeholder,
          &::-webkit-input-placeholder,
          &::-ms-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #cccccc;
          }
          ::v-deep .el-select {
            width: 130px;
            margin: 0 -15px;
            border-right: 1px solid rgba(0, 0, 0, 0.15);
          }
        }
        ::v-deep .el-input-group__prepend {
          padding: 0 15px;
        }
      }
    }
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}

::v-deep .ui-box-dialog {
  border-radius: 12px;
  .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  .ui-box-from-questionnaireDetail {
    padding-top: 29px;
    .el-form-item {
      margin-top: 24px;
      margin-bottom: 0;
      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      &.inline {
        display: inline-block;
        vertical-align: top;
      }
      &.height-auto {
        .el-form-item__content {
          height: auto;
        }
      }

      .el-form-item__label {
        height: 32px;
        line-height: 32px;
        padding: 0;
        margin: 0;
      }
      .el-form-item__error {
        padding-left: 20px;
      }
      .el-form-item__content {
        height: 100%;
        padding-left: 20px;
        line-height: 32px;
      }
      .addOption {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #1890ff;
      }
      .width645 {
        width: 645px;
      }
      .remove {
        color: #f56c6c;
        margin-left: 10px;
      }
      .ui-box-from-questionnaireDetail-input {
        width: 500px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.width645 {
          width: 645px;
        }
        .el-icon-time,
        .el-icon-arrow-down,
        .el-icon-arrow-up,
        .el-icon-date,
        .el-icon-date,
        .el-range__icon,
        .el-range-separator,
        .el-range-input,
        .el-range__close-icon,
        .el-icon-circle-close,
        .el-icon-arrow-up,
        .el-icon-date,
        .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
        .el-input__inner::-webkit-outer-spin-button,
        .el-input__inner::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        .el-input__inner[type="number"] {
          -moz-appearance: textfield;
        }
        .el-input-group__prepend {
          background-color: #fff;
          height: 30px;
          border: none;
          &::-moz-placeholder,
          &::-webkit-input-placeholder,
          &::-ms-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #cccccc;
          }
          .el-select {
            width: 130px;
            margin: 0 -15px;
            border-right: 1px solid rgba(0, 0, 0, 0.15);
          }
        }
        .el-input-group__prepend {
          padding: 0 15px;
        }
      }
    }
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}
</style>